// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var ListType$ReactHooksTemplate = require("../data_fields/listType.res.js");
var DataField$ReactHooksTemplate = require("../data_fields/dataField.res.js");
var DataRestriction$ReactHooksTemplate = require("../settings/dataRestriction.res.js");
var MultipleSelectBox$ReactHooksTemplate = require("../common/MultipleSelectBox.res.js");

function DataFieldDropDown(props) {
  var deleteFilter = props.deleteFilter;
  var createNewFilter = props.createNewFilter;
  var updateReport = props.updateReport;
  var dataFields = props.dataFields;
  var dataRestriction = props.dataRestriction;
  var handleOptionChange = function (option) {
    var updatedOptions = List.exists((function (item) {
            return item === option;
          }), DataRestriction$ReactHooksTemplate.value(dataRestriction)) ? List.filter(function (item) {
              return item !== option;
            })(DataRestriction$ReactHooksTemplate.value(dataRestriction)) : List.append({
            hd: option,
            tl: /* [] */0
          }, DataRestriction$ReactHooksTemplate.value(dataRestriction));
    Curry._1(updateReport, DataRestriction$ReactHooksTemplate.setValue(dataRestriction, updatedOptions));
  };
  var listType = DataField$ReactHooksTemplate.dataType(DataRestriction$ReactHooksTemplate.dataField(dataRestriction));
  var tmp;
  if (listType.TAG === "ListType") {
    var listType$1 = listType._0;
    tmp = JsxRuntime.jsx(MultipleSelectBox$ReactHooksTemplate.make, {
          options: ListType$ReactHooksTemplate.options(listType$1),
          placeholder: "Select the options",
          handleChange: handleOptionChange,
          selectedOptions: List.filter(function (x) {
                  return List.exists((function (d) {
                                return d === x;
                              }), DataRestriction$ReactHooksTemplate.value(dataRestriction));
                })(ListType$ReactHooksTemplate.options(listType$1)),
          className: "w-9/12 border px-3 py-2 border-gray-400 cursor-pointer bg-white rounded capitalize text-sm",
          optionsHoverColor: "hover:bg-pigmentblue hover:text-white",
          listBoxCss: "py-2 w-9/12 "
        });
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "Data Field",
                            className: "w-1/5 text-sm font-medium py-2"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("select", {
                                          children: [
                                            JsxRuntime.jsx("option", {
                                                  children: "Select Data Field",
                                                  disabled: true,
                                                  value: ""
                                                }, "0"),
                                            $$Array.of_list(Belt_List.map(dataFields, (function (dataField) {
                                                        return JsxRuntime.jsx("option", {
                                                                    children: DataField$ReactHooksTemplate.name(dataField),
                                                                    value: DataField$ReactHooksTemplate.name(dataField)
                                                                  }, DataField$ReactHooksTemplate.name(dataField));
                                                      })))
                                          ],
                                          className: "w-9/12 border px-3 py-2 border-gray-400 rounded text-sm capitalize",
                                          value: DataField$ReactHooksTemplate.name(DataRestriction$ReactHooksTemplate.dataField(dataRestriction)),
                                          onChange: (function (e) {
                                              var dataFieldName = Utils$ReactHooksTemplate.formTargetValue(e);
                                              var selectedDataField = List.find((function (x) {
                                                      return DataField$ReactHooksTemplate.name(x) === dataFieldName;
                                                    }), dataFields);
                                              Curry._1(updateReport, DataRestriction$ReactHooksTemplate.setValue(DataRestriction$ReactHooksTemplate.setDataField(dataRestriction, selectedDataField), /* [] */0));
                                            })
                                        })
                                  }),
                              tmp,
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("img", {
                                                  className: "h-4 w-4",
                                                  src: Image$ReactHooksTemplate.plusCircle
                                                }),
                                            className: "flex items-center bg-ghostwhite border border-gray-400 shadow-inner rounded py-2 px-3 text-xs font-normal cursor-pointer",
                                            onClick: (function (param) {
                                                Curry._1(createNewFilter, undefined);
                                              })
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("img", {
                                                  className: "h-4 w-4",
                                                  src: Image$ReactHooksTemplate.trashGrey
                                                }),
                                            className: "flex items-center bg-salmon border border-gray-400 shadow-inner\n                      rounded py-2 px-3 text-xs font-normal cursor-pointer text-white",
                                            onClick: (function (param) {
                                                Curry._1(deleteFilter, undefined);
                                              })
                                          })
                                    ],
                                    className: "flex gap-2"
                                  })
                            ],
                            className: "flex flex-col w-4/5 gap-4"
                          })
                    ],
                    className: "flex items-start w-full gap-1"
                  }),
              className: "flex flex-col mb-6"
            });
}

var make = DataFieldDropDown;

exports.make = make;
/* react/jsx-runtime Not a pure module */
